import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Sparkle } from "@phosphor-icons/react";

export default function Splash() {
  const nav = useNavigate();
  useEffect(() => {
    const onboarded = localStorage.getItem("lumen_onboarded");
    const t = setTimeout(() => nav(onboarded ? "/home" : "/onboarding"), 2400);
    return () => clearTimeout(t);
  }, [nav]);

  return (
    <div className="mesh-bg grain min-h-screen flex flex-col items-center justify-center relative overflow-hidden" data-testid="splash-screen">
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        <div className="w-[300px] h-[300px] rounded-full bg-indigo-500/20 blur-3xl pulse-glow" />
      </div>

      <motion.div
        initial={{ opacity: 0, scale: 0.92 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 1.0, ease: [0.22, 1, 0.36, 1] }}
        className="relative z-10 flex flex-col items-center"
      >
        <div className="relative w-20 h-20 rounded-3xl glass-strong flex items-center justify-center mb-6 overflow-hidden shimmer-line">
          <Sparkle size={32} weight="fill" className="text-white" />
        </div>
        <h1 className="font-display text-5xl font-light tracking-tight text-white">SuperLearn AI</h1>
        <p className="mt-3 text-xs uppercase tracking-[0.4em] text-zinc-500">AI-native learning platform</p>
      </motion.div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.4 }}
        className="absolute bottom-10 text-[11px] tracking-widest uppercase text-zinc-600"
      >
        Calibrating mentors…
      </motion.div>
    </div>
  );
}
